import { axios } from '@/utils/request'
import { filterData } from '@/utils/util'

const api = {
  subaccountlist: '/configmanage/subaccountlist',
  listsub: '/admin/listsub',
  addConfig: '/configmanage/add',
  editConfig: '/configmanage/edit',
  editAccount: '/admin/edit',
  addSubAccount: '/admin/subadd',
  editauditscope: '/admin/editauditscope',
  getMainList: '/admin/list',
  configsave: '/egc/config/save',
  typelist: '/egc/type',
  list: '/egc/config/list', //权限管理 权限配置
  configuserlist: '/egc/config/user/list',
  authconfig:'/egc/config/setting',
  getCustomConfig:'/aac/config',
  saveCustomConfig:'/aac/edit',
}

// 查询业务来源配置
export function subaccountlist (params) {
  return axios({
    url: api.subaccountlist,
    method: 'get',
    params: filterData(params),
    func:'查询业务来源配置'
  })
}

// 查询子账号列表
export function listsub (params) {
  console.log(params)
  return axios({
    url: api.listsub,
    method: 'get',
    params: filterData(params),
    func:'查询子账号列表'
  })
}

// 新增业务来源
export function addConfig (data) {
  return axios({
    url: api.addConfig,
    method: 'post',
    data: filterData(data),
    func:'新增业务来源'
  })
}

// 编辑业务来源
export function editConfig (data) {
  return axios({
    url: api.editConfig,
    method: 'post',
    data: filterData(data),
    func:'编辑业务来源'
  })
}

// 编辑账户
export function editAccount (data) {
  return axios({
    url: api.editAccount,
    method: 'post',
    data: filterData(data),
    func:'编辑账户'
  })
}

// 添加子账户
export function addSubAccount (data) {
  return axios({
    url: api.addSubAccount,
    method: 'post',
    data: filterData(data),
    func:'添加子账户'
  })
}

// 编辑子账户
export function editauditscope (data) {
  return axios({
    url: api.editauditscope,
    method: 'post',
    data: filterData(data),
    func:'编辑子账户'
  })
}

// 查询审核主账号
export function getMainList (params) {
  return axios({
    url: api.getMainList,
    method: 'get',
    params: filterData(params),
    func:'查询审核主账号'
  })
}

// 配置权限
export function saveConfigEgc(parameter) {
  return axios({
    url: api.configsave,
    method: 'post',
    data: parameter || {},
    headers: {
      'Content-Type':'application/json;utf-8'
    },
    func:'配置权限'
  })
}

// 查询拒绝原因列表
export function getEgcTypeList(parameter) {
  return axios({
    url: api.typelist,
    method: 'get',
    params: parameter || {},
    func:'查询拒绝原因列表'
  })
}
// 查询权限配置
export function getEgcConfigList(parameter) {
  return axios({
    url: api.list,
    method: 'get',
    params: parameter || {},
    func:'查询权限配置'
  })
}

export function getEgcConfigUserList(parameter) {
  return axios({
    url: api.configuserlist,
    method: 'get',
    params: parameter || {}
  })
}
// 新增审核权限
export function saveAuthConfig(parameter) {
  return axios({
    url: api.authconfig,
    method: 'post',
    data: parameter || {},
    headers: {
      'Content-Type':'application/json;utf-8'
    },
    func:'新增/编辑权限配置'
  })
}
// 获取自定义配置
export function getCustomConfig(params={}) {
  return axios({
    url: api.getCustomConfig,
    method: 'get',
    params
  })
}
// 保存自定义配置
export function saveCustomConfig(data) {
  return axios({
    url: api.saveCustomConfig,
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json;utf-8'
    },
    isJson: 1,
  })
}